import { render } from "./AcceptableUsePolicy.vue?vue&type=template&id=3654cd47"
const script = {}
script.render = render

export default script